<template>
    <div class="cooperation-main">
         <!-- 头部 -->
      <headers></headers>
        <section class="ban-bg">
            
        </section>
        <section class="ban">
            <div class="col">
                <!-- <div>
                    <h1 class="title1">即刻加入平台会员  尊享众多精彩权益</h1>

                    <p style="
                    font-weight: 300;
                    font-size: 30px;
                    margin-top: 50px;
                        text-align: center;
                    color: #FFFFFF;
                    line-height: 60px;">ExpoSCM旗下众多数字化产品和增值服务，全面覆盖展装企业日常管理和市场拓展需要</p>
                </div> -->
            </div>
        </section>
        <div style="">
            <section class="col" style="padding-top: 50px;">
                <div class="list-hxys">
                    <dl>
                        <dt>平台会员</dt>
                        <dd>赋能会展行业中下游企业，<br>
                            提供智能、高能、全能大服务！</dd>
                    </dl>
                    <dl>
                        <dt>项目合作</dt>
                        <dd>线上升级线下承接，<br>
                            让您办展省心又高效！</dd>
                    </dl>
                    <dl>
                        <dt>共建生态</dt>
                        <dd>想要拓宽销售渠道，<br>
                            来这就对了！</dd>
                    </dl>
                </div>
            </section>
            <section class="col" style="padding-top: 50px;">
                <h4 class="title5" style="margin-bottom: 50px;">平台会员</h4>
                <div class="pthy-img-box" style="position: relative;">
                    <img style="width: 100%;" src="../images/img-21.png" alt="">
                    <a class="a-btn" href="./activity.html"></a>
                </div>
            </section>
            <section id="xmhz" class="col" style="padding-top: 50px;">
                <h4 class="title5" style="margin-bottom: 50px;">项目合作</h4>
                <div class="div1">
                    <div>
                        <p class="p1" style="margin-bottom: 13px;">线下服务</p>
                        <p class="p2" style="margin-bottom: 50px;">展会一站式承接服务</p>
                        <p class="p3" style="margin-bottom: 13px;">线上赋能</p>
                        <p class="p2">
                            主办：招展云、观众云
                        </p>
                        <p class="p2">
                            场馆：场馆云
                        </p>
                        <p class="p2">
                            主场：主场云、升级服务+移动端小程序
                        </p>
                    </div>
                    <img src="../images/img-8.png" alt="">
                </div>
            </section>
            <section id="gjst" class="col" style="padding-top: 50px;">
                <h4 class="title5" style="margin-bottom: 50px;">共建生态</h4>
                <div class="div2">
                    <div>
                        <p><label for="">商旅服务：</label>机票车票、旅游路线、住宿酒店…

                        </p>
                        <p><label for="">礼品鲜花：</label>定制礼品、促销礼品…

                        </p>
                        <p><label for="">租赁服务：</label>电脑、打印机、桌椅沙发…

                        </p>
                        <p><label for="">印刷物料：</label>物料设计、制作印刷、卡牌定制、包装定制…

                        </p>
                        <p><label for="">餐饮外卖：</label>团队餐、工作餐…
                        </p>
                    </div>
                    <div>
                        <p><label for="">专业人员：</label>礼仪服务、主持人、文案翻译、同声传译…</p>
                        <p><label for="">演艺服务：</label>舞蹈杂技、歌手乐队、其他…</p>
                        <p><label for="">场地服务：</label>综合体、酒店、会展中心、剧院、体育馆…</p>
                        <p><label for="">其他服务：</label>法务、企业培训、招聘…</p>
                    </div>
                </div>
            </section>
            <section class="col" style="padding-top: 50px;">
                <h4 class="title5" style="margin-bottom: 30px;">加入会展生态圈</h4>
                <p style="text-align: center;font-size: 16px; line-height: 28px; margin-bottom: 30px;">我们都是会展生态圈的一部分<br>
                    不论您是主办方、主场服务商、搭建服务商还是其他会展供应商，都欢迎您加入会展供应链平台<br>
                    让我们一起合作共赢！</p>
            </section>
        </div>
        <div class="bg2">
            <div class="bg3">
                <div class="col box-kf">
                    <span class="span1">咨询热线</span>
                    <p>010-86460766-861</p>
                    <img src="../images/img-kf.png" alt="">
                    <span class="span2">企微客服</span>
                </div>
            </div>
        </div>
        <!-- 尾部 -->
      <footers></footers>
      <!-- 右侧吸附客服咨询按钮 -->
      <contact></contact>
    </div>
</template>
    <script>
    import headers from '@/common/header';
    import footers from '@/common/Footer';
    import contact from '@/components/contact';
    export default {
        components: {
            headers,
            footers,
            contact
        }
    }
            
    </script>


// WEBPACK FOOTER //
// src/page/cooperation.vue